"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WorkingTimeTypeSelect = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const elements_1 = require("@src/components/elements");
const types_1 = require("@src/types");
const react_intl_1 = require("react-intl");
const { Option } = elements_1.Select;
const WorkingTimeTypeSelect = ({ value, defaultValue, onChange, ...otherProps }) => {
    const intl = (0, react_intl_1.useIntl)();
    return ((0, jsx_runtime_1.jsx)(elements_1.Select, { value: value, defaultValue: defaultValue, onChange: onChange, ...otherProps, children: Object.keys(types_1.WorkingTimeType).map(key => ((0, jsx_runtime_1.jsx)(Option, { value: types_1.WorkingTimeType[key], children: types_1.WorkingTimeTypeMap[intl.locale][key.toLowerCase()] }, key))) }));
};
exports.WorkingTimeTypeSelect = WorkingTimeTypeSelect;
